import { environment } from 'environments/environment';

export class LotasConfig {
    public static location = window.location;
    public static remote = environment.remote;
    public static production = false;
    public static DOMAIN = environment.domain;
    public static PORT = LotasConfig.remote ? '443' : '8080';
    public static DATABASE = "lotas";
    public static SERVER_URL = LotasConfig.remote ? "https://" + LotasConfig.DOMAIN + ":" + LotasConfig.PORT + "/server" : window.location.protocol + "//" + LotasConfig.DOMAIN + "/server";
    public static DATABASE_URL = LotasConfig.remote ? "https://" + LotasConfig.DOMAIN + ":" + LotasConfig.PORT + "/api" : window.location.protocol + "//" + LotasConfig.DOMAIN + "/api";
    public static PREFIX = "";
    public static SUMMER_CAMPAIGN_START_MONTH = 6; // サマーキャンペーン開始月
    public static SUMMER_CAMPAIGN_END_MONTH = 7; // サマーキャンペーン終了月
    public static AUTUMN_CAMPAIGN_START_MONTH = 10;	// 秋のキャンペーン開始月
    public static AUTUMN_CAMPAIGN_END_MONTH = 11;	// 秋のキャンペーン終了月
    public static SPRING_CAMPAIGN_START_MONTH = 2;	// 春のキャンペーン開始月
    public static SPRING_CAMPAIGN_END_MONTH = 3;	// 春のキャンペーン終了月
    public static ENTERABLE_UNDER_POINT = 70;		// 参加率計算時の最低値
    public static ENTERABLE_POINT_MAX = 100;	// 参加率得点の最大値
    public static REACH_POINT_MAX = 150;	// 達成率得点の最大値
    public static EXCELLENT_REACH_POINT_MAX = 100;	// 優績を取るための達成率の基準値
    public static EXCELLENT_POINT_10_MAX = 300;	// 優績ポイント(10点の場合)
    public static EXCELLENT_POINT_15_MAX = 350;	// 優績ポイント(15点の場合)
    public static EXCELLENT_POINT = {
        0: 0,
        5: 300,
        10: 300,
        15: 350
    };
    public static EXECUTIVE_BONUS_POINT = [5, 10, 15];
    public static CAMPAIGN_FIXED_POINT_TYPE = ["2020_summer"];
    public static CAMPAIGN_FIXED_POINT = [10];
    public static CAMPAIGN_LMLS_ADD_YEAR = 2015;
    public static ITEM_NUM_MAX = 10;
    public static SUBITEM_NUM_MAX = 10;
    public static AREA_NUM_MAX = 10;
    public static MAKE_PLAN_NUM_MAX = 6;
    public static LOGIN_HISTORY_NUM_MAX = 18;
    public static CAMPAIGN_GRAPH_RANGE_MAX = 7;	// キャンペーン進捗グラフに表示する集計日の最大数

    public static COOPERATION_SETTING_TYPE_RAW = 1;
    public static COOPERATION_SETTING_TYPE_UNIT = 2;

    public static PERFECT_AWARD_ITEM_NUM = 6;
    public static SECOND_PERFECT_AWARD_ITEM_NUM = 5;

    public static CAMPAIGN_FIXED_RATE_TYPE = ["2020_summer"];
    // issue #31: 種目別の特別措置を表現できるよう "fiscal_quarter_item" 形式のキーもサポート。
    //   "fiscal_quarter"           … その fiscal/quarter のすべての種目を固定 (旧来形式)
    //   "fiscal_quarter_<item>"    … その fiscal/quarter の対応 item だけ固定。calculate.service.ts
    //                                 の match では hasOwnProperty で対応 item のキーが入っているか
    //                                 ガードしてから rates を上書きする (詳細は getReachBranchRate)。
    public static QUARTER_FIXED_RATE_TYPE = ["2020_1", "2020_2", "2026_1_LO"];
    public static CAMPAIGN_FIXED_RATE = [{LT: 0.27, LO: 0.6, LE: 0.3, LL: 0.06}];
    public static QUARTER_FIXED_RATE = [{LT: 0.7, LO: 2.0, LE: 1.0, LL: 0.14}, {LT: 0.7, LO: 2.0, LE: 1.0, LL: 0.14}, {LO: 2.2}];

    public static REACH_PATTERN_1 = 0.70;	// 達成率 75%
    public static REACH_PATTERN_2 = 0.80;	// 達成率 85%
    public static REACH_PATTERN_3 = 0.90;	// 達成率 90%
    public static REACH_PATTERN_4 = 0.95;	// 達成率 95%

    public static POINT_SETTINGS = {
        "2026": [
            {
                title: "＜同友拡充部門＞", table: [
                    {name: "同友拡充（30点/1入会）", point: ""},
                    {name: "同友数純増（10点ｘ純増数）", point: ""},
                ]
            },
            {
                title: "＜基本＞", table: [
                    {name: "例会議事録の提出（10点/月）", point: 120},
                    {name: "例会出席（10x出席率/月）", point: 120},
                    {name: "機関会議の出欠（-100/欠席）", point: ""},
                    {name: "データベース構築（5x入力率/月）", point: 60},
                    {name: "ロータスとわかる店づくり（100点ｘ達成率）", point: 100},
                    {name: "統一カラー車の保有（50点ｘ達成率）", point: 50},
                    {name: "VI顔ピクトの掲示（100点ｘ達成率）", point: 100},
                ]
            },
            {
                title: "", table: [
                    {name: "支部活動", point: 125},
                    {name: "地域での奉仕活動", point: 25},
                    {name: "献血活動ボーナス得点", point: 25},
                    {name: "アンケート（10点ｘ提出率）", point: 10},
                ]
            }
        ],
        "2025": [
            {
                title: "＜同友拡充部門＞", table: [
                    {name: "同友拡充（30点/1入会）", point: ""},
                    {name: "同友数純増（30点ｘ純増数）", point: ""},
                ]
            },
            {
                title: "＜基本＞", table: [
                    {name: "例会議事録の提出（10点/月）", point: 120},
                    {name: "例会出席（10x出席率/月）", point: 120},
                    {name: "機関会議の出欠（-100/欠席）", point: ""},
                    {name: "アンケート（10点ｘ提出率）", point: 10},
                    {name: "データベース構築（5x入力率/月）", point: 60},
                    {name: "ロータスとわかる店づくり（100点ｘ達成率）", point: 100},
                    {name: "統一カラー車の保有（50点ｘ達成率）", point: 50},
                    {name: "VI顔ピクトの掲示（100点ｘ達成率）", point: 100},
                ]
            },
            {
                title: "", table: [
                    {name: "経営者向け勉強会の実施", point: 120},
                    {name: "ロータススタンダード研修", point: 100},
                    {name: "支部活動", point: 120},
                    {name: "地域での奉仕活動", point: 40},
                ]
            }
        ],
        "2024": [
            {
                title: "＜基本＞", table: [
                    {name: "例会議事録の提出（10点/月）", point: 120},
                    {name: "例会出席（10x出席率/月）", point: 120},
                    {name: "本部会議への出席（-100/欠席）", point: ""},
                    {name: "アンケート（10点ｘ提出率）", point: 10},
                    {name: "データベース入力（5x入力率/月）", point: 60},
                    {name: "ロータスとわかる店づくり（CI）（100点ｘ達成率）", point: 100},
                    {name: "統一カラー車（50点ｘ達成率）", point: 50},
                    {name: "支部顔ピクト（VI）（100点ｘ達成率）", point: 100},
                ]
            },
            {
                title: "", table: [
                    {name: "同友拡充（30点/1入会）", point: ""},
                    {name: "3年未満退会（1社ｘ▲30点）", point: ""},
                    {name: "同友数純増（30点ｘ純増数）", point: ""},
                ]
            },
            {
                title: "＜支部活動＞", table: [
                    {name: "事業適正チェック（15点×実施率）", point: 15},
                    {name: "経営に関する勉強会実施（30点ｘ参加率ｘ3企画）", point: 90},
                    {name: "ハラスメントチェック（15点ｘ実施率）", point: 15},
                    {name: "ロータススタンダード研修[基礎編]浸透率（70点ｘ浸透率）", point: 70},
                    {name: "ロータス白書15（30点ｘ提出率）", point: 30},
                    {name: "支部統一施策（30点ｘ2企画）", point: 60},
                    {name: "同友企業HP設置率（50点ｘ設置率）", point: 50},
                    {name: "地域での奉仕活動", point: 30},
                    {name: "広報宣伝活動", point: 20},
                ]
            }
        ],
        "2023": [
            {
                title: "＜基本＞", table: [
                    {name: "例会議事録の提出（10点/月）", point: 120},
                    {name: "例会出席（10x出席率/月）", point: 120},
                    {name: "本部会議への出席（-100/欠席）", point: ""},
                    {name: "アンケート（30点ｘ提出率）", point: 30},
                    {name: "データベース入力（5x入力率/月）", point: 60},
                    {name: "ロータスとわかる店づくり（CI）（100点ｘ達成率）", point: 100},
                    {name: "統一カラー車（50点ｘ達成率）", point: 50},
                    {name: "顔ピクト（VI）（100点ｘ達成率）", point: 100},
                ]
            },
            {
                title: "", table: [
                    {name: "同友拡充（30点/1入会）", point: ""},
                    {name: "3年未満退会（1社ｘ▲30点）", point: ""},
                    {name: "同友数純増（30点ｘ純増数）", point: ""},
                ]
            },
            {
                title: "＜支部活動＞", table: [
                    {name: "支部ビジョン（50点/2回提出）", point: 50},
                    {name: "経営に関する勉強会実施（20点/1開催につき）", point: 40},
                    {name: "支部法人によるSDGsの活動", point: 20},
                    {name: "ロータススタンダード研修[基礎編]浸透率（50点ｘ浸透率）", point: 50},
                    {name: "教育委員会推奨研修会", point: 320},
                    {name: "支部活動（20点ｘ4規格）", point: 80},
                    {name: "同友企業HP設置率（50点ｘ設置率）", point: 50},
                    {name: "地域での奉仕活動", point: 30},
                    {name: "広報宣伝活動", point: 20},
                ]
            }
        ],
        "2022": [
            {
                title: "＜基本＞", table: [
                    {name: "例会運営要綱の提出", point: 60},
                    {name: "例会議事録の提出", point: 60},
                    {name: "例会出席率", point: 120},
                    {name: "機関会議の出欠", point: 100},
                    {name: "アンケート調査", point: 30},
                    {name: "データベース構築", point: 60},
                    {name: "ロータスとわかる店づくり", point: 100},
                    {name: "統一カラー車の保有", point: 50},
                    {name: "VI顔ピクトの掲示", point: 100},
                ]
            },
            {
                title: "", table: [
                    {name: "同友拡充", point: "x20"},
                    {name: "同友数純増", point: "x20"},
                ]
            },
            {
                title: "＜支部活動＞", table: [
                    {name: "支部ビジョン", point: 50},
                    {name: "経営に関する勉強会の実施", point: 30},
                    {name: "SDGsの宣言と発表", point: 30},
                    {name: "ロータススタンダード研修修了者配置", point: 50},
                    {name: "ロータススタンダード研修修了者配置率100％", point: 10},
                    {name: "支部活動", point: 120},
                    {name: "地域での奉仕活動", point: 30},
                    {name: "広報宣伝活動", point: 30},
                ]
            }
        ],
        "0": [
            {
                title: "＜基本＞", table: [
                    {name: "支部ビジョン", point: 100},
                    {name: "例会運営要綱の提出", point: 60},
                    {name: "例会議事録の提出", point: 60},
                    {name: "例会出席率", point: 120},
                    {name: "機関会議の出欠", point: 100},
                    {name: "同友拡充", point: "--"},
                    {name: "アンケート調査", point: 30},
                    {name: "データベース構築", point: 60}
                ]
            },
            {
                title: "＜本部施策＞", table: [
                    {name: "社員教育関連研修会", point: 30},
                    {name: "経営に対する取り組み", point: 30},
                    {name: "環境への取り組み", point: 30},
                    {name: "ロータスと分かる店つくり", point: 100},
                    {name: "統一カラー車の保有", point: 50},
                    {name: "VI・顔ピクトの掲示", point: 50}
                ]
            },
            {
                title: "＜支部活動＞", table: [
                    {name: "勉強会実施", point: 80},
                    {name: "支部内統一施策実施", point: 60},
                    {name: "地域への奉仕活動", point: 60},
                ]
            },
            {
                title: "", table: [
                    {name: "広告宣伝活動", point: 50},
                ]
            }
        ]
    };

}

